import { LinkItEmail, LinkItUrl } from "react-linkify-it";

const RegisterAccountSuccess = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center">
        <p className="text-gray-700 text-[16px] md:text-[20px] leading-[24px] md:leading-[30px] font-normal">
          この度は、
          <br />
          アートシフトトレーニングアプリに、ご登録ありがとうございます。
          <br />
          「自動返信」で登録確認メールを送信しました。
          <br />
          <br />
          ＜注意＞実際のアプリのご利用開始は、事務局側でアプリ登録後となります。
          <br />
          アプリ登録が終わり次第、別メールでログイン情報をお送りします。
          <br />
          <br />
          ※もし、まだ「自動返信メールが届いていない」という方は、
          <br/>
          ご入力内容に誤りがある可能性がありますので
          <br />
          こちらへご連絡ください。
          <br />
          <LinkItUrl className="text-primary-500 underline">
            <LinkItEmail className="text-primary-500 underline">
              artshift@blog-positioning05.com
            </LinkItEmail>
          </LinkItUrl>
        </p>
      </div>
    </>
  );
};

export default RegisterAccountSuccess;
